module.exports = __webpack_public_path__ + "img/monthly-budget-planner_B09QNYN35J.62863b41.jpg";